module.exports = __webpack_public_path__ + "img/twitter-grey.78d1d8b0.svg";